/* eslint-disable */
// prettier-ignore
import { AspidaClient, BasicHeaders, dataToURLString } from 'aspida'
// prettier-ignore
import { Methods as Methods0 } from '.'
// prettier-ignore
import { Methods as Methods1 } from './auth/login'
// prettier-ignore
import { Methods as Methods2 } from './auth/me'
// prettier-ignore
import { Methods as Methods3 } from './auth/reset-password'
// prettier-ignore
import { Methods as Methods4 } from './auth/update-password'
// prettier-ignore
import { Methods as Methods5 } from './brand-skus'
// prettier-ignore
import { Methods as Methods6 } from './brand-skus/suggest'
// prettier-ignore
import { Methods as Methods7 } from './category/child'
// prettier-ignore
import { Methods as Methods8 } from './category/parent'
// prettier-ignore
import { Methods as Methods9 } from './chain-stores'
// prettier-ignore
import { Methods as Methods10 } from './chain-stores/_id@number/receipt-pattern'
// prettier-ignore
import { Methods as Methods11 } from './chain-stores/_id@number/set-receipt-pattern'
// prettier-ignore
import { Methods as Methods12 } from './changed-matcheds'
// prettier-ignore
import { Methods as Methods13 } from './channels'
// prettier-ignore
import { Methods as Methods14 } from './condition'
// prettier-ignore
import { Methods as Methods15 } from './condition/_condition_id@number'
// prettier-ignore
import { Methods as Methods16 } from './gcs/questionnaire-image'
// prettier-ignore
import { Methods as Methods17 } from './items/_id@string'
// prettier-ignore
import { Methods as Methods18 } from './items/new'
// prettier-ignore
import { Methods as Methods19 } from './items/re'
// prettier-ignore
import { Methods as Methods20 } from './logs'
// prettier-ignore
import { Methods as Methods21 } from './logs/logs.csv'
// prettier-ignore
import { Methods as Methods22 } from './logs/new-progresses'
// prettier-ignore
import { Methods as Methods23 } from './logs/progresses'
// prettier-ignore
import { Methods as Methods24 } from './matcheds'
// prettier-ignore
import { Methods as Methods25 } from './matcheds/_id@string'
// prettier-ignore
import { Methods as Methods26 } from './matcheds/by-name'
// prettier-ignore
import { Methods as Methods27 } from './monitors'
// prettier-ignore
import { Methods as Methods28 } from './monitors/_id@string'
// prettier-ignore
import { Methods as Methods29 } from './monitors/internal'
// prettier-ignore
import { Methods as Methods30 } from './monitors/internal/_id@string'
// prettier-ignore
import { Methods as Methods31 } from './notices'
// prettier-ignore
import { Methods as Methods32 } from './notices/_id@number'
// prettier-ignore
import { Methods as Methods33 } from './place'
// prettier-ignore
import { Methods as Methods34 } from './qlogs'
// prettier-ignore
import { Methods as Methods35 } from './qlogs/qlogs.csv'
// prettier-ignore
import { Methods as Methods36 } from './question'
// prettier-ignore
import { Methods as Methods37 } from './question/_question_id@number'
// prettier-ignore
import { Methods as Methods38 } from './question-answer/_id@number'
// prettier-ignore
import { Methods as Methods39 } from './question-answer/upload-image'
// prettier-ignore
import { Methods as Methods40 } from './questionnaire'
// prettier-ignore
import { Methods as Methods41 } from './questionnaire/_id@number'
// prettier-ignore
import { Methods as Methods42 } from './questionnaire/_id@number/answers.csv'
// prettier-ignore
import { Methods as Methods43 } from './questionnaire/_id@number/copy'
// prettier-ignore
import { Methods as Methods44 } from './questionnaire/_id@string/_answerId@string'
// prettier-ignore
import { Methods as Methods45 } from './questionnaire/additional-issue/_id@number'
// prettier-ignore
import { Methods as Methods46 } from './questionnaire/count-target/_id@number'
// prettier-ignore
import { Methods as Methods47 } from './questionnaire/fixed/_questionnaireId@string'
// prettier-ignore
import { Methods as Methods48 } from './questionnaire/fixed-preview/_questionnaireId@string'
// prettier-ignore
import { Methods as Methods49 } from './questionnaire/issue/_id@number'
// prettier-ignore
import { Methods as Methods50 } from './questionnaire/preview/_questionnaireId@string'
// prettier-ignore
import { Methods as Methods51 } from './questionnaire/preview-url/_id@number'
// prettier-ignore
import { Methods as Methods52 } from './questionnaire-answer'
// prettier-ignore
import { Methods as Methods53 } from './questionnaire-answer/_id@number'
// prettier-ignore
import { Methods as Methods54 } from './questionnaire-answer/_questionnaireId@string/_answerId@string'
// prettier-ignore
import { Methods as Methods55 } from './questionnaire-answer/internal/_monitorId@string'
// prettier-ignore
import { Methods as Methods56 } from './questionnaire-answer/results-requests'
// prettier-ignore
import { Methods as Methods57 } from './questionnaire-page'
// prettier-ignore
import { Methods as Methods58 } from './questionnaire-page/_page_id@number'
// prettier-ignore
import { Methods as Methods59 } from './receipts'
// prettier-ignore
import { Methods as Methods60 } from './receipts/_id@number'
// prettier-ignore
import { Methods as Methods61 } from './receipts/bigquery.csv'
// prettier-ignore
import { Methods as Methods62 } from './receipts/checkDuplicated'
// prettier-ignore
import { Methods as Methods63 } from './receipts/chobirich/remaind-count'
// prettier-ignore
import { Methods as Methods64 } from './receipts/chobirich/upload-image'
// prettier-ignore
import { Methods as Methods65 } from './receipts/contributers'
// prettier-ignore
import { Methods as Methods66 } from './receipts/contributers.csv'
// prettier-ignore
import { Methods as Methods67 } from './receipts/internal/remained-count/_monitorId@string'
// prettier-ignore
import { Methods as Methods68 } from './receipts/is-existing-image-id/_imageId@string'
// prettier-ignore
import { Methods as Methods69 } from './receipts/mock-questionnaire/_id@string/_questionnaireId@number'
// prettier-ignore
import { Methods as Methods70 } from './receipts/results-requests'
// prettier-ignore
import { Methods as Methods71 } from './receipts/results-requests-by-ids'
// prettier-ignore
import { Methods as Methods72 } from './receipts/snapShot'
// prettier-ignore
import { Methods as Methods73 } from './receipts/summaries'
// prettier-ignore
import { Methods as Methods74 } from './recommend'
// prettier-ignore
import { Methods as Methods75 } from './shops'
// prettier-ignore
import { Methods as Methods76 } from './shops/_id@string'
// prettier-ignore
import { Methods as Methods77 } from './slogs'
// prettier-ignore
import { Methods as Methods78 } from './slogs/slogs.csv'
// prettier-ignore
import { Methods as Methods79 } from './special-offer-receipts'
// prettier-ignore
import { Methods as Methods80 } from './special-offer-receipts/_id@number'
// prettier-ignore
import { Methods as Methods81 } from './special-offer-receipts/internal'
// prettier-ignore
import { Methods as Methods82 } from './special-offer-receipts/internal-by-imported-at'
// prettier-ignore
import { Methods as Methods83 } from './special-offers'
// prettier-ignore
import { Methods as Methods84 } from './special-offers/_id@string'
// prettier-ignore
import { Methods as Methods85 } from './special-offers/internal'
// prettier-ignore
import { Methods as Methods86 } from './users'
// prettier-ignore
import { Methods as Methods87 } from './users/_id@number'

// prettier-ignore
const api = <T>({ baseURL, fetch }: AspidaClient<T>) => {
  const prefix = (baseURL === undefined ? '' : baseURL).replace(/\/$/, '')
  const PATH0 = '/auth/login'
  const PATH1 = '/auth/me'
  const PATH2 = '/auth/reset-password'
  const PATH3 = '/auth/update-password'
  const PATH4 = '/brand-skus'
  const PATH5 = '/brand-skus/suggest'
  const PATH6 = '/category/child'
  const PATH7 = '/category/parent'
  const PATH8 = '/chain-stores'
  const PATH9 = '/receipt-pattern'
  const PATH10 = '/set-receipt-pattern'
  const PATH11 = '/changed-matcheds'
  const PATH12 = '/channels'
  const PATH13 = '/condition'
  const PATH14 = '/gcs/questionnaire-image'
  const PATH15 = '/items'
  const PATH16 = '/items/new'
  const PATH17 = '/items/re'
  const PATH18 = '/logs'
  const PATH19 = '/logs/logs.csv'
  const PATH20 = '/logs/new-progresses'
  const PATH21 = '/logs/progresses'
  const PATH22 = '/matcheds'
  const PATH23 = '/matcheds/by-name'
  const PATH24 = '/monitors'
  const PATH25 = '/monitors/internal'
  const PATH26 = '/notices'
  const PATH27 = '/place'
  const PATH28 = '/qlogs'
  const PATH29 = '/qlogs/qlogs.csv'
  const PATH30 = '/question'
  const PATH31 = '/question-answer'
  const PATH32 = '/question-answer/upload-image'
  const PATH33 = '/questionnaire'
  const PATH34 = '/answers.csv'
  const PATH35 = '/copy'
  const PATH36 = '/questionnaire/additional-issue'
  const PATH37 = '/questionnaire/count-target'
  const PATH38 = '/questionnaire/fixed'
  const PATH39 = '/questionnaire/fixed-preview'
  const PATH40 = '/questionnaire/issue'
  const PATH41 = '/questionnaire/preview'
  const PATH42 = '/questionnaire/preview-url'
  const PATH43 = '/questionnaire-answer'
  const PATH44 = '/questionnaire-answer/internal'
  const PATH45 = '/questionnaire-answer/results-requests'
  const PATH46 = '/questionnaire-page'
  const PATH47 = '/receipts'
  const PATH48 = '/receipts/bigquery.csv'
  const PATH49 = '/receipts/checkDuplicated'
  const PATH50 = '/receipts/chobirich/remaind-count'
  const PATH51 = '/receipts/chobirich/upload-image'
  const PATH52 = '/receipts/contributers'
  const PATH53 = '/receipts/contributers.csv'
  const PATH54 = '/receipts/internal/remained-count'
  const PATH55 = '/receipts/is-existing-image-id'
  const PATH56 = '/receipts/mock-questionnaire'
  const PATH57 = '/receipts/results-requests'
  const PATH58 = '/receipts/results-requests-by-ids'
  const PATH59 = '/receipts/snapShot'
  const PATH60 = '/receipts/summaries'
  const PATH61 = '/recommend'
  const PATH62 = '/shops'
  const PATH63 = '/slogs'
  const PATH64 = '/slogs/slogs.csv'
  const PATH65 = '/special-offer-receipts'
  const PATH66 = '/special-offer-receipts/internal'
  const PATH67 = '/special-offer-receipts/internal-by-imported-at'
  const PATH68 = '/special-offers'
  const PATH69 = '/special-offers/internal'
  const PATH70 = '/users'
  const GET = 'GET'
  const POST = 'POST'
  const PUT = 'PUT'
  const DELETE = 'DELETE'

  return {
    auth: {
      login: {
        post: (option: { body: Methods1['post']['reqBody'], config?: T }) =>
          fetch<Methods1['post']['resBody'], BasicHeaders, Methods1['post']['status']>(prefix, PATH0, POST, option).json(),
        $post: (option: { body: Methods1['post']['reqBody'], config?: T }) =>
          fetch<Methods1['post']['resBody'], BasicHeaders, Methods1['post']['status']>(prefix, PATH0, POST, option).json().then(r => r.body),
        $path: () => `${prefix}${PATH0}`
      },
      me: {
        get: (option?: { config?: T }) =>
          fetch<Methods2['get']['resBody'], BasicHeaders, Methods2['get']['status']>(prefix, PATH1, GET, option).json(),
        $get: (option?: { config?: T }) =>
          fetch<Methods2['get']['resBody'], BasicHeaders, Methods2['get']['status']>(prefix, PATH1, GET, option).json().then(r => r.body),
        $path: () => `${prefix}${PATH1}`
      },
      reset_password: {
        put: (option: { body: Methods3['put']['reqBody'], config?: T }) =>
          fetch<Methods3['put']['resBody'], BasicHeaders, Methods3['put']['status']>(prefix, PATH2, PUT, option).text(),
        $put: (option: { body: Methods3['put']['reqBody'], config?: T }) =>
          fetch<Methods3['put']['resBody'], BasicHeaders, Methods3['put']['status']>(prefix, PATH2, PUT, option).text().then(r => r.body),
        $path: () => `${prefix}${PATH2}`
      },
      update_password: {
        put: (option?: { config?: T }) =>
          fetch<Methods4['put']['resBody'], BasicHeaders, Methods4['put']['status']>(prefix, PATH3, PUT, option).json(),
        $put: (option?: { config?: T }) =>
          fetch<Methods4['put']['resBody'], BasicHeaders, Methods4['put']['status']>(prefix, PATH3, PUT, option).json().then(r => r.body),
        $path: () => `${prefix}${PATH3}`
      }
    },
    brand_skus: {
      suggest: {
        get: (option?: { query?: Methods6['get']['query'], config?: T }) =>
          fetch<Methods6['get']['resBody'], BasicHeaders, Methods6['get']['status']>(prefix, PATH5, GET, option).json(),
        $get: (option?: { query?: Methods6['get']['query'], config?: T }) =>
          fetch<Methods6['get']['resBody'], BasicHeaders, Methods6['get']['status']>(prefix, PATH5, GET, option).json().then(r => r.body),
        $path: (option?: { method?: 'get'; query: Methods6['get']['query'] }) =>
          `${prefix}${PATH5}${option && option.query ? `?${dataToURLString(option.query)}` : ''}`
      },
      get: (option?: { query?: Methods5['get']['query'], config?: T }) =>
        fetch<Methods5['get']['resBody'], BasicHeaders, Methods5['get']['status']>(prefix, PATH4, GET, option).json(),
      $get: (option?: { query?: Methods5['get']['query'], config?: T }) =>
        fetch<Methods5['get']['resBody'], BasicHeaders, Methods5['get']['status']>(prefix, PATH4, GET, option).json().then(r => r.body),
      $path: (option?: { method?: 'get'; query: Methods5['get']['query'] }) =>
        `${prefix}${PATH4}${option && option.query ? `?${dataToURLString(option.query)}` : ''}`
    },
    category: {
      child: {
        get: (option?: { query?: Methods7['get']['query'], config?: T }) =>
          fetch<Methods7['get']['resBody'], BasicHeaders, Methods7['get']['status']>(prefix, PATH6, GET, option).json(),
        $get: (option?: { query?: Methods7['get']['query'], config?: T }) =>
          fetch<Methods7['get']['resBody'], BasicHeaders, Methods7['get']['status']>(prefix, PATH6, GET, option).json().then(r => r.body),
        $path: (option?: { method?: 'get'; query: Methods7['get']['query'] }) =>
          `${prefix}${PATH6}${option && option.query ? `?${dataToURLString(option.query)}` : ''}`
      },
      parent: {
        get: (option?: { config?: T }) =>
          fetch<Methods8['get']['resBody'], BasicHeaders, Methods8['get']['status']>(prefix, PATH7, GET, option).json(),
        $get: (option?: { config?: T }) =>
          fetch<Methods8['get']['resBody'], BasicHeaders, Methods8['get']['status']>(prefix, PATH7, GET, option).json().then(r => r.body),
        $path: () => `${prefix}${PATH7}`
      }
    },
    chain_stores: {
      _id: (val1: number) => {
        const prefix1 = `${PATH8}/${val1}`

        return {
          receipt_pattern: {
            get: (option?: { config?: T }) =>
              fetch<Methods10['get']['resBody'], BasicHeaders, Methods10['get']['status']>(prefix, `${prefix1}${PATH9}`, GET, option).json(),
            $get: (option?: { config?: T }) =>
              fetch<Methods10['get']['resBody'], BasicHeaders, Methods10['get']['status']>(prefix, `${prefix1}${PATH9}`, GET, option).json().then(r => r.body),
            $path: () => `${prefix}${prefix1}${PATH9}`
          },
          set_receipt_pattern: {
            get: (option?: { config?: T }) =>
              fetch<Methods11['get']['resBody'], BasicHeaders, Methods11['get']['status']>(prefix, `${prefix1}${PATH10}`, GET, option).json(),
            $get: (option?: { config?: T }) =>
              fetch<Methods11['get']['resBody'], BasicHeaders, Methods11['get']['status']>(prefix, `${prefix1}${PATH10}`, GET, option).json().then(r => r.body),
            $path: () => `${prefix}${prefix1}${PATH10}`
          }
        }
      },
      get: (option?: { query?: Methods9['get']['query'], config?: T }) =>
        fetch<Methods9['get']['resBody'], BasicHeaders, Methods9['get']['status']>(prefix, PATH8, GET, option).json(),
      $get: (option?: { query?: Methods9['get']['query'], config?: T }) =>
        fetch<Methods9['get']['resBody'], BasicHeaders, Methods9['get']['status']>(prefix, PATH8, GET, option).json().then(r => r.body),
      $path: (option?: { method?: 'get'; query: Methods9['get']['query'] }) =>
        `${prefix}${PATH8}${option && option.query ? `?${dataToURLString(option.query)}` : ''}`
    },
    changed_matcheds: {
      post: (option: { body: Methods12['post']['reqBody'], config?: T }) =>
        fetch<Methods12['post']['resBody'], BasicHeaders, Methods12['post']['status']>(prefix, PATH11, POST, option).json(),
      $post: (option: { body: Methods12['post']['reqBody'], config?: T }) =>
        fetch<Methods12['post']['resBody'], BasicHeaders, Methods12['post']['status']>(prefix, PATH11, POST, option).json().then(r => r.body),
      $path: () => `${prefix}${PATH11}`
    },
    channels: {
      get: (option?: { config?: T }) =>
        fetch<Methods13['get']['resBody'], BasicHeaders, Methods13['get']['status']>(prefix, PATH12, GET, option).json(),
      $get: (option?: { config?: T }) =>
        fetch<Methods13['get']['resBody'], BasicHeaders, Methods13['get']['status']>(prefix, PATH12, GET, option).json().then(r => r.body),
      $path: () => `${prefix}${PATH12}`
    },
    condition: {
      _condition_id: (val1: number) => {
        const prefix1 = `${PATH13}/${val1}`

        return {
          put: (option: { body: Methods15['put']['reqBody'], config?: T }) =>
            fetch<Methods15['put']['resBody'], BasicHeaders, Methods15['put']['status']>(prefix, prefix1, PUT, option).json(),
          $put: (option: { body: Methods15['put']['reqBody'], config?: T }) =>
            fetch<Methods15['put']['resBody'], BasicHeaders, Methods15['put']['status']>(prefix, prefix1, PUT, option).json().then(r => r.body),
          delete: (option?: { config?: T }) =>
            fetch<Methods15['delete']['resBody'], BasicHeaders, Methods15['delete']['status']>(prefix, prefix1, DELETE, option).json(),
          $delete: (option?: { config?: T }) =>
            fetch<Methods15['delete']['resBody'], BasicHeaders, Methods15['delete']['status']>(prefix, prefix1, DELETE, option).json().then(r => r.body),
          $path: () => `${prefix}${prefix1}`
        }
      },
      get: (option: { query: Methods14['get']['query'], config?: T }) =>
        fetch<Methods14['get']['resBody'], BasicHeaders, Methods14['get']['status']>(prefix, PATH13, GET, option).json(),
      $get: (option: { query: Methods14['get']['query'], config?: T }) =>
        fetch<Methods14['get']['resBody'], BasicHeaders, Methods14['get']['status']>(prefix, PATH13, GET, option).json().then(r => r.body),
      post: (option: { body: Methods14['post']['reqBody'], config?: T }) =>
        fetch<Methods14['post']['resBody'], BasicHeaders, Methods14['post']['status']>(prefix, PATH13, POST, option).json(),
      $post: (option: { body: Methods14['post']['reqBody'], config?: T }) =>
        fetch<Methods14['post']['resBody'], BasicHeaders, Methods14['post']['status']>(prefix, PATH13, POST, option).json().then(r => r.body),
      $path: (option?: { method?: 'get'; query: Methods14['get']['query'] }) =>
        `${prefix}${PATH13}${option && option.query ? `?${dataToURLString(option.query)}` : ''}`
    },
    gcs: {
      questionnaire_image: {
        post: (option: { body: Methods16['post']['reqBody'], config?: T }) =>
          fetch<Methods16['post']['resBody'], BasicHeaders, Methods16['post']['status']>(prefix, PATH14, POST, option, 'FormData').text(),
        $post: (option: { body: Methods16['post']['reqBody'], config?: T }) =>
          fetch<Methods16['post']['resBody'], BasicHeaders, Methods16['post']['status']>(prefix, PATH14, POST, option, 'FormData').text().then(r => r.body),
        $path: () => `${prefix}${PATH14}`
      }
    },
    items: {
      _id: (val1: string) => {
        const prefix1 = `${PATH15}/${val1}`

        return {
          get: (option?: { config?: T }) =>
            fetch<Methods17['get']['resBody'], BasicHeaders, Methods17['get']['status']>(prefix, prefix1, GET, option).json(),
          $get: (option?: { config?: T }) =>
            fetch<Methods17['get']['resBody'], BasicHeaders, Methods17['get']['status']>(prefix, prefix1, GET, option).json().then(r => r.body),
          put: (option: { body: Methods17['put']['reqBody'], config?: T }) =>
            fetch<Methods17['put']['resBody'], BasicHeaders, Methods17['put']['status']>(prefix, prefix1, PUT, option).json(),
          $put: (option: { body: Methods17['put']['reqBody'], config?: T }) =>
            fetch<Methods17['put']['resBody'], BasicHeaders, Methods17['put']['status']>(prefix, prefix1, PUT, option).json().then(r => r.body),
          delete: (option?: { config?: T }) =>
            fetch<Methods17['delete']['resBody'], BasicHeaders, Methods17['delete']['status']>(prefix, prefix1, DELETE, option).json(),
          $delete: (option?: { config?: T }) =>
            fetch<Methods17['delete']['resBody'], BasicHeaders, Methods17['delete']['status']>(prefix, prefix1, DELETE, option).json().then(r => r.body),
          $path: () => `${prefix}${prefix1}`
        }
      },
      new: {
        get: (option: { query: Methods18['get']['query'], config?: T }) =>
          fetch<Methods18['get']['resBody'], BasicHeaders, Methods18['get']['status']>(prefix, PATH16, GET, option).json(),
        $get: (option: { query: Methods18['get']['query'], config?: T }) =>
          fetch<Methods18['get']['resBody'], BasicHeaders, Methods18['get']['status']>(prefix, PATH16, GET, option).json().then(r => r.body),
        $path: (option?: { method?: 'get'; query: Methods18['get']['query'] }) =>
          `${prefix}${PATH16}${option && option.query ? `?${dataToURLString(option.query)}` : ''}`
      },
      re: {
        get: (option: { query: Methods19['get']['query'], config?: T }) =>
          fetch<Methods19['get']['resBody'], BasicHeaders, Methods19['get']['status']>(prefix, PATH17, GET, option).json(),
        $get: (option: { query: Methods19['get']['query'], config?: T }) =>
          fetch<Methods19['get']['resBody'], BasicHeaders, Methods19['get']['status']>(prefix, PATH17, GET, option).json().then(r => r.body),
        $path: (option?: { method?: 'get'; query: Methods19['get']['query'] }) =>
          `${prefix}${PATH17}${option && option.query ? `?${dataToURLString(option.query)}` : ''}`
      }
    },
    logs: {
      logs_csv: {
        get: (option?: { query?: Methods21['get']['query'], config?: T }) =>
          fetch<void, BasicHeaders, Methods21['get']['status']>(prefix, PATH19, GET, option).send(),
        $get: (option?: { query?: Methods21['get']['query'], config?: T }) =>
          fetch<void, BasicHeaders, Methods21['get']['status']>(prefix, PATH19, GET, option).send().then(r => r.body),
        $path: (option?: { method?: 'get'; query: Methods21['get']['query'] }) =>
          `${prefix}${PATH19}${option && option.query ? `?${dataToURLString(option.query)}` : ''}`
      },
      new_progresses: {
        get: (option: { query: Methods22['get']['query'], config?: T }) =>
          fetch<Methods22['get']['resBody'], BasicHeaders, Methods22['get']['status']>(prefix, PATH20, GET, option).json(),
        $get: (option: { query: Methods22['get']['query'], config?: T }) =>
          fetch<Methods22['get']['resBody'], BasicHeaders, Methods22['get']['status']>(prefix, PATH20, GET, option).json().then(r => r.body),
        $path: (option?: { method?: 'get'; query: Methods22['get']['query'] }) =>
          `${prefix}${PATH20}${option && option.query ? `?${dataToURLString(option.query)}` : ''}`
      },
      progresses: {
        get: (option: { query: Methods23['get']['query'], config?: T }) =>
          fetch<Methods23['get']['resBody'], BasicHeaders, Methods23['get']['status']>(prefix, PATH21, GET, option).json(),
        $get: (option: { query: Methods23['get']['query'], config?: T }) =>
          fetch<Methods23['get']['resBody'], BasicHeaders, Methods23['get']['status']>(prefix, PATH21, GET, option).json().then(r => r.body),
        $path: (option?: { method?: 'get'; query: Methods23['get']['query'] }) =>
          `${prefix}${PATH21}${option && option.query ? `?${dataToURLString(option.query)}` : ''}`
      },
      post: (option: { body: Methods20['post']['reqBody'], config?: T }) =>
        fetch<Methods20['post']['resBody'], BasicHeaders, Methods20['post']['status']>(prefix, PATH18, POST, option).json(),
      $post: (option: { body: Methods20['post']['reqBody'], config?: T }) =>
        fetch<Methods20['post']['resBody'], BasicHeaders, Methods20['post']['status']>(prefix, PATH18, POST, option).json().then(r => r.body),
      get: (option?: { query?: Methods20['get']['query'], config?: T }) =>
        fetch<Methods20['get']['resBody'], BasicHeaders, Methods20['get']['status']>(prefix, PATH18, GET, option).json(),
      $get: (option?: { query?: Methods20['get']['query'], config?: T }) =>
        fetch<Methods20['get']['resBody'], BasicHeaders, Methods20['get']['status']>(prefix, PATH18, GET, option).json().then(r => r.body),
      $path: (option?: { method?: 'get'; query: Methods20['get']['query'] }) =>
        `${prefix}${PATH18}${option && option.query ? `?${dataToURLString(option.query)}` : ''}`
    },
    matcheds: {
      _id: (val1: string) => {
        const prefix1 = `${PATH22}/${val1}`

        return {
          put: (option: { body: Methods25['put']['reqBody'], config?: T }) =>
            fetch<Methods25['put']['resBody'], BasicHeaders, Methods25['put']['status']>(prefix, prefix1, PUT, option).json(),
          $put: (option: { body: Methods25['put']['reqBody'], config?: T }) =>
            fetch<Methods25['put']['resBody'], BasicHeaders, Methods25['put']['status']>(prefix, prefix1, PUT, option).json().then(r => r.body),
          delete: (option?: { config?: T }) =>
            fetch<void, BasicHeaders, Methods25['delete']['status']>(prefix, prefix1, DELETE, option).send(),
          $delete: (option?: { config?: T }) =>
            fetch<void, BasicHeaders, Methods25['delete']['status']>(prefix, prefix1, DELETE, option).send().then(r => r.body),
          $path: () => `${prefix}${prefix1}`
        }
      },
      by_name: {
        put: (option: { body: Methods26['put']['reqBody'], query: Methods26['put']['query'], config?: T }) =>
          fetch<void, BasicHeaders, Methods26['put']['status']>(prefix, PATH23, PUT, option).send(),
        $put: (option: { body: Methods26['put']['reqBody'], query: Methods26['put']['query'], config?: T }) =>
          fetch<void, BasicHeaders, Methods26['put']['status']>(prefix, PATH23, PUT, option).send().then(r => r.body),
        delete: (option: { query: Methods26['delete']['query'], config?: T }) =>
          fetch<void, BasicHeaders, Methods26['delete']['status']>(prefix, PATH23, DELETE, option).send(),
        $delete: (option: { query: Methods26['delete']['query'], config?: T }) =>
          fetch<void, BasicHeaders, Methods26['delete']['status']>(prefix, PATH23, DELETE, option).send().then(r => r.body),
        $path: (option?: { method: 'put'; query: Methods26['put']['query'] } | { method: 'delete'; query: Methods26['delete']['query'] }) =>
          `${prefix}${PATH23}${option && option.query ? `?${dataToURLString(option.query)}` : ''}`
      },
      get: (option?: { query?: Methods24['get']['query'], config?: T }) =>
        fetch<Methods24['get']['resBody'], BasicHeaders, Methods24['get']['status']>(prefix, PATH22, GET, option).json(),
      $get: (option?: { query?: Methods24['get']['query'], config?: T }) =>
        fetch<Methods24['get']['resBody'], BasicHeaders, Methods24['get']['status']>(prefix, PATH22, GET, option).json().then(r => r.body),
      $path: (option?: { method?: 'get'; query: Methods24['get']['query'] }) =>
        `${prefix}${PATH22}${option && option.query ? `?${dataToURLString(option.query)}` : ''}`
    },
    monitors: {
      _id: (val1: string) => {
        const prefix1 = `${PATH24}/${val1}`

        return {
          get: (option?: { config?: T }) =>
            fetch<Methods28['get']['resBody'], BasicHeaders, Methods28['get']['status']>(prefix, prefix1, GET, option).json(),
          $get: (option?: { config?: T }) =>
            fetch<Methods28['get']['resBody'], BasicHeaders, Methods28['get']['status']>(prefix, prefix1, GET, option).json().then(r => r.body),
          put: (option: { body: Methods28['put']['reqBody'], config?: T }) =>
            fetch<Methods28['put']['resBody'], BasicHeaders, Methods28['put']['status']>(prefix, prefix1, PUT, option).json(),
          $put: (option: { body: Methods28['put']['reqBody'], config?: T }) =>
            fetch<Methods28['put']['resBody'], BasicHeaders, Methods28['put']['status']>(prefix, prefix1, PUT, option).json().then(r => r.body),
          delete: (option?: { config?: T }) =>
            fetch<Methods28['delete']['resBody'], BasicHeaders, Methods28['delete']['status']>(prefix, prefix1, DELETE, option).json(),
          $delete: (option?: { config?: T }) =>
            fetch<Methods28['delete']['resBody'], BasicHeaders, Methods28['delete']['status']>(prefix, prefix1, DELETE, option).json().then(r => r.body),
          $path: () => `${prefix}${prefix1}`
        }
      },
      internal: {
        _id: (val2: string) => {
          const prefix2 = `${PATH25}/${val2}`

          return {
            post: (option: { body: Methods30['post']['reqBody'], config?: T }) =>
              fetch<Methods30['post']['resBody'], BasicHeaders, Methods30['post']['status']>(prefix, prefix2, POST, option).json(),
            $post: (option: { body: Methods30['post']['reqBody'], config?: T }) =>
              fetch<Methods30['post']['resBody'], BasicHeaders, Methods30['post']['status']>(prefix, prefix2, POST, option).json().then(r => r.body),
            $path: () => `${prefix}${prefix2}`
          }
        },
        post: (option: { body: Methods29['post']['reqBody'], config?: T }) =>
          fetch<Methods29['post']['resBody'], BasicHeaders, Methods29['post']['status']>(prefix, PATH25, POST, option).json(),
        $post: (option: { body: Methods29['post']['reqBody'], config?: T }) =>
          fetch<Methods29['post']['resBody'], BasicHeaders, Methods29['post']['status']>(prefix, PATH25, POST, option).json().then(r => r.body),
        $path: () => `${prefix}${PATH25}`
      },
      get: (option?: { config?: T }) =>
        fetch<Methods27['get']['resBody'], BasicHeaders, Methods27['get']['status']>(prefix, PATH24, GET, option).json(),
      $get: (option?: { config?: T }) =>
        fetch<Methods27['get']['resBody'], BasicHeaders, Methods27['get']['status']>(prefix, PATH24, GET, option).json().then(r => r.body),
      $path: () => `${prefix}${PATH24}`
    },
    notices: {
      _id: (val1: number) => {
        const prefix1 = `${PATH26}/${val1}`

        return {
          get: (option?: { config?: T }) =>
            fetch<Methods32['get']['resBody'], BasicHeaders, Methods32['get']['status']>(prefix, prefix1, GET, option).json(),
          $get: (option?: { config?: T }) =>
            fetch<Methods32['get']['resBody'], BasicHeaders, Methods32['get']['status']>(prefix, prefix1, GET, option).json().then(r => r.body),
          put: (option: { body: Methods32['put']['reqBody'], config?: T }) =>
            fetch<Methods32['put']['resBody'], BasicHeaders, Methods32['put']['status']>(prefix, prefix1, PUT, option).json(),
          $put: (option: { body: Methods32['put']['reqBody'], config?: T }) =>
            fetch<Methods32['put']['resBody'], BasicHeaders, Methods32['put']['status']>(prefix, prefix1, PUT, option).json().then(r => r.body),
          delete: (option?: { config?: T }) =>
            fetch<Methods32['delete']['resBody'], BasicHeaders, Methods32['delete']['status']>(prefix, prefix1, DELETE, option).json(),
          $delete: (option?: { config?: T }) =>
            fetch<Methods32['delete']['resBody'], BasicHeaders, Methods32['delete']['status']>(prefix, prefix1, DELETE, option).json().then(r => r.body),
          $path: () => `${prefix}${prefix1}`
        }
      },
      post: (option: { body: Methods31['post']['reqBody'], config?: T }) =>
        fetch<Methods31['post']['resBody'], BasicHeaders, Methods31['post']['status']>(prefix, PATH26, POST, option).json(),
      $post: (option: { body: Methods31['post']['reqBody'], config?: T }) =>
        fetch<Methods31['post']['resBody'], BasicHeaders, Methods31['post']['status']>(prefix, PATH26, POST, option).json().then(r => r.body),
      get: (option?: { config?: T }) =>
        fetch<Methods31['get']['resBody'], BasicHeaders, Methods31['get']['status']>(prefix, PATH26, GET, option).json(),
      $get: (option?: { config?: T }) =>
        fetch<Methods31['get']['resBody'], BasicHeaders, Methods31['get']['status']>(prefix, PATH26, GET, option).json().then(r => r.body),
      $path: () => `${prefix}${PATH26}`
    },
    place: {
      get: (option: { query: Methods33['get']['query'], config?: T }) =>
        fetch<Methods33['get']['resBody'], BasicHeaders, Methods33['get']['status']>(prefix, PATH27, GET, option).json(),
      $get: (option: { query: Methods33['get']['query'], config?: T }) =>
        fetch<Methods33['get']['resBody'], BasicHeaders, Methods33['get']['status']>(prefix, PATH27, GET, option).json().then(r => r.body),
      $path: (option?: { method?: 'get'; query: Methods33['get']['query'] }) =>
        `${prefix}${PATH27}${option && option.query ? `?${dataToURLString(option.query)}` : ''}`
    },
    qlogs: {
      qlogs_csv: {
        get: (option?: { config?: T }) =>
          fetch<void, BasicHeaders, Methods35['get']['status']>(prefix, PATH29, GET, option).send(),
        $get: (option?: { config?: T }) =>
          fetch<void, BasicHeaders, Methods35['get']['status']>(prefix, PATH29, GET, option).send().then(r => r.body),
        $path: () => `${prefix}${PATH29}`
      },
      post: (option: { body: Methods34['post']['reqBody'], config?: T }) =>
        fetch<Methods34['post']['resBody'], BasicHeaders, Methods34['post']['status']>(prefix, PATH28, POST, option).json(),
      $post: (option: { body: Methods34['post']['reqBody'], config?: T }) =>
        fetch<Methods34['post']['resBody'], BasicHeaders, Methods34['post']['status']>(prefix, PATH28, POST, option).json().then(r => r.body),
      get: (option?: { config?: T }) =>
        fetch<Methods34['get']['resBody'], BasicHeaders, Methods34['get']['status']>(prefix, PATH28, GET, option).json(),
      $get: (option?: { config?: T }) =>
        fetch<Methods34['get']['resBody'], BasicHeaders, Methods34['get']['status']>(prefix, PATH28, GET, option).json().then(r => r.body),
      $path: () => `${prefix}${PATH28}`
    },
    question: {
      _question_id: (val1: number) => {
        const prefix1 = `${PATH30}/${val1}`

        return {
          get: (option?: { config?: T }) =>
            fetch<Methods37['get']['resBody'], BasicHeaders, Methods37['get']['status']>(prefix, prefix1, GET, option).json(),
          $get: (option?: { config?: T }) =>
            fetch<Methods37['get']['resBody'], BasicHeaders, Methods37['get']['status']>(prefix, prefix1, GET, option).json().then(r => r.body),
          put: (option: { body: Methods37['put']['reqBody'], config?: T }) =>
            fetch<Methods37['put']['resBody'], BasicHeaders, Methods37['put']['status']>(prefix, prefix1, PUT, option).json(),
          $put: (option: { body: Methods37['put']['reqBody'], config?: T }) =>
            fetch<Methods37['put']['resBody'], BasicHeaders, Methods37['put']['status']>(prefix, prefix1, PUT, option).json().then(r => r.body),
          delete: (option?: { config?: T }) =>
            fetch<Methods37['delete']['resBody'], BasicHeaders, Methods37['delete']['status']>(prefix, prefix1, DELETE, option).json(),
          $delete: (option?: { config?: T }) =>
            fetch<Methods37['delete']['resBody'], BasicHeaders, Methods37['delete']['status']>(prefix, prefix1, DELETE, option).json().then(r => r.body),
          $path: () => `${prefix}${prefix1}`
        }
      },
      get: (option: { query: Methods36['get']['query'], config?: T }) =>
        fetch<Methods36['get']['resBody'], BasicHeaders, Methods36['get']['status']>(prefix, PATH30, GET, option).json(),
      $get: (option: { query: Methods36['get']['query'], config?: T }) =>
        fetch<Methods36['get']['resBody'], BasicHeaders, Methods36['get']['status']>(prefix, PATH30, GET, option).json().then(r => r.body),
      post: (option: { body: Methods36['post']['reqBody'], config?: T }) =>
        fetch<Methods36['post']['resBody'], BasicHeaders, Methods36['post']['status']>(prefix, PATH30, POST, option).json(),
      $post: (option: { body: Methods36['post']['reqBody'], config?: T }) =>
        fetch<Methods36['post']['resBody'], BasicHeaders, Methods36['post']['status']>(prefix, PATH30, POST, option).json().then(r => r.body),
      $path: (option?: { method?: 'get'; query: Methods36['get']['query'] }) =>
        `${prefix}${PATH30}${option && option.query ? `?${dataToURLString(option.query)}` : ''}`
    },
    question_answer: {
      _id: (val1: number) => {
        const prefix1 = `${PATH31}/${val1}`

        return {
          put: (option: { body: Methods38['put']['reqBody'], config?: T }) =>
            fetch<Methods38['put']['resBody'], BasicHeaders, Methods38['put']['status']>(prefix, prefix1, PUT, option).json(),
          $put: (option: { body: Methods38['put']['reqBody'], config?: T }) =>
            fetch<Methods38['put']['resBody'], BasicHeaders, Methods38['put']['status']>(prefix, prefix1, PUT, option).json().then(r => r.body),
          $path: () => `${prefix}${prefix1}`
        }
      },
      upload_image: {
        post: (option: { body: Methods39['post']['reqBody'], config?: T }) =>
          fetch<Methods39['post']['resBody'], BasicHeaders, Methods39['post']['status']>(prefix, PATH32, POST, option, 'FormData').text(),
        $post: (option: { body: Methods39['post']['reqBody'], config?: T }) =>
          fetch<Methods39['post']['resBody'], BasicHeaders, Methods39['post']['status']>(prefix, PATH32, POST, option, 'FormData').text().then(r => r.body),
        $path: () => `${prefix}${PATH32}`
      }
    },
    questionnaire: {
      _id_number: (val1: number) => {
        const prefix1 = `${PATH33}/${val1}`

        return {
          answers_csv: {
            get: (option?: { config?: T }) =>
              fetch<void, BasicHeaders, Methods42['get']['status']>(prefix, `${prefix1}${PATH34}`, GET, option).send(),
            $get: (option?: { config?: T }) =>
              fetch<void, BasicHeaders, Methods42['get']['status']>(prefix, `${prefix1}${PATH34}`, GET, option).send().then(r => r.body),
            $path: () => `${prefix}${prefix1}${PATH34}`
          },
          copy: {
            post: (option?: { config?: T }) =>
              fetch<Methods43['post']['resBody'], BasicHeaders, Methods43['post']['status']>(prefix, `${prefix1}${PATH35}`, POST, option).json(),
            $post: (option?: { config?: T }) =>
              fetch<Methods43['post']['resBody'], BasicHeaders, Methods43['post']['status']>(prefix, `${prefix1}${PATH35}`, POST, option).json().then(r => r.body),
            $path: () => `${prefix}${prefix1}${PATH35}`
          },
          get: (option?: { config?: T }) =>
            fetch<Methods41['get']['resBody'], BasicHeaders, Methods41['get']['status']>(prefix, prefix1, GET, option).json(),
          $get: (option?: { config?: T }) =>
            fetch<Methods41['get']['resBody'], BasicHeaders, Methods41['get']['status']>(prefix, prefix1, GET, option).json().then(r => r.body),
          put: (option: { body: Methods41['put']['reqBody'], config?: T }) =>
            fetch<Methods41['put']['resBody'], BasicHeaders, Methods41['put']['status']>(prefix, prefix1, PUT, option).json(),
          $put: (option: { body: Methods41['put']['reqBody'], config?: T }) =>
            fetch<Methods41['put']['resBody'], BasicHeaders, Methods41['put']['status']>(prefix, prefix1, PUT, option).json().then(r => r.body),
          delete: (option?: { config?: T }) =>
            fetch<Methods41['delete']['resBody'], BasicHeaders, Methods41['delete']['status']>(prefix, prefix1, DELETE, option).json(),
          $delete: (option?: { config?: T }) =>
            fetch<Methods41['delete']['resBody'], BasicHeaders, Methods41['delete']['status']>(prefix, prefix1, DELETE, option).json().then(r => r.body),
          $path: () => `${prefix}${prefix1}`
        }
      },
      _id_string: (val1: string) => {
        const prefix1 = `${PATH33}/${val1}`

        return {
          _answerId: (val2: string) => {
            const prefix2 = `${prefix1}/${val2}`

            return {
              get: (option: { query: Methods44['get']['query'], config?: T }) =>
                fetch<Methods44['get']['resBody'], BasicHeaders, Methods44['get']['status']>(prefix, prefix2, GET, option).json(),
              $get: (option: { query: Methods44['get']['query'], config?: T }) =>
                fetch<Methods44['get']['resBody'], BasicHeaders, Methods44['get']['status']>(prefix, prefix2, GET, option).json().then(r => r.body),
              $path: (option?: { method?: 'get'; query: Methods44['get']['query'] }) =>
                `${prefix}${prefix2}${option && option.query ? `?${dataToURLString(option.query)}` : ''}`
            }
          }
        }
      },
      additional_issue: {
        _id: (val2: number) => {
          const prefix2 = `${PATH36}/${val2}`

          return {
            put: (option?: { config?: T }) =>
              fetch<Methods45['put']['resBody'], BasicHeaders, Methods45['put']['status']>(prefix, prefix2, PUT, option).json(),
            $put: (option?: { config?: T }) =>
              fetch<Methods45['put']['resBody'], BasicHeaders, Methods45['put']['status']>(prefix, prefix2, PUT, option).json().then(r => r.body),
            $path: () => `${prefix}${prefix2}`
          }
        }
      },
      count_target: {
        _id: (val2: number) => {
          const prefix2 = `${PATH37}/${val2}`

          return {
            get: (option?: { config?: T }) =>
              fetch<Methods46['get']['resBody'], BasicHeaders, Methods46['get']['status']>(prefix, prefix2, GET, option).json(),
            $get: (option?: { config?: T }) =>
              fetch<Methods46['get']['resBody'], BasicHeaders, Methods46['get']['status']>(prefix, prefix2, GET, option).json().then(r => r.body),
            $path: () => `${prefix}${prefix2}`
          }
        }
      },
      fixed: {
        _questionnaireId: (val2: string) => {
          const prefix2 = `${PATH38}/${val2}`

          return {
            get: (option?: { config?: T }) =>
              fetch<Methods47['get']['resBody'], BasicHeaders, Methods47['get']['status']>(prefix, prefix2, GET, option).json(),
            $get: (option?: { config?: T }) =>
              fetch<Methods47['get']['resBody'], BasicHeaders, Methods47['get']['status']>(prefix, prefix2, GET, option).json().then(r => r.body),
            $path: () => `${prefix}${prefix2}`
          }
        }
      },
      fixed_preview: {
        _questionnaireId: (val2: string) => {
          const prefix2 = `${PATH39}/${val2}`

          return {
            get: (option: { query: Methods48['get']['query'], config?: T }) =>
              fetch<Methods48['get']['resBody'], BasicHeaders, Methods48['get']['status']>(prefix, prefix2, GET, option).json(),
            $get: (option: { query: Methods48['get']['query'], config?: T }) =>
              fetch<Methods48['get']['resBody'], BasicHeaders, Methods48['get']['status']>(prefix, prefix2, GET, option).json().then(r => r.body),
            $path: (option?: { method?: 'get'; query: Methods48['get']['query'] }) =>
              `${prefix}${prefix2}${option && option.query ? `?${dataToURLString(option.query)}` : ''}`
          }
        }
      },
      issue: {
        _id: (val2: number) => {
          const prefix2 = `${PATH40}/${val2}`

          return {
            put: (option?: { config?: T }) =>
              fetch<Methods49['put']['resBody'], BasicHeaders, Methods49['put']['status']>(prefix, prefix2, PUT, option).json(),
            $put: (option?: { config?: T }) =>
              fetch<Methods49['put']['resBody'], BasicHeaders, Methods49['put']['status']>(prefix, prefix2, PUT, option).json().then(r => r.body),
            $path: () => `${prefix}${prefix2}`
          }
        }
      },
      preview: {
        _questionnaireId: (val2: string) => {
          const prefix2 = `${PATH41}/${val2}`

          return {
            get: (option: { query: Methods50['get']['query'], config?: T }) =>
              fetch<Methods50['get']['resBody'], BasicHeaders, Methods50['get']['status']>(prefix, prefix2, GET, option).json(),
            $get: (option: { query: Methods50['get']['query'], config?: T }) =>
              fetch<Methods50['get']['resBody'], BasicHeaders, Methods50['get']['status']>(prefix, prefix2, GET, option).json().then(r => r.body),
            $path: (option?: { method?: 'get'; query: Methods50['get']['query'] }) =>
              `${prefix}${prefix2}${option && option.query ? `?${dataToURLString(option.query)}` : ''}`
          }
        }
      },
      preview_url: {
        _id: (val2: number) => {
          const prefix2 = `${PATH42}/${val2}`

          return {
            get: (option?: { config?: T }) =>
              fetch<Methods51['get']['resBody'], BasicHeaders, Methods51['get']['status']>(prefix, prefix2, GET, option).text(),
            $get: (option?: { config?: T }) =>
              fetch<Methods51['get']['resBody'], BasicHeaders, Methods51['get']['status']>(prefix, prefix2, GET, option).text().then(r => r.body),
            $path: () => `${prefix}${prefix2}`
          }
        }
      },
      get: (option?: { query?: Methods40['get']['query'], config?: T }) =>
        fetch<Methods40['get']['resBody'], BasicHeaders, Methods40['get']['status']>(prefix, PATH33, GET, option).json(),
      $get: (option?: { query?: Methods40['get']['query'], config?: T }) =>
        fetch<Methods40['get']['resBody'], BasicHeaders, Methods40['get']['status']>(prefix, PATH33, GET, option).json().then(r => r.body),
      post: (option: { body: Methods40['post']['reqBody'], config?: T }) =>
        fetch<Methods40['post']['resBody'], BasicHeaders, Methods40['post']['status']>(prefix, PATH33, POST, option).json(),
      $post: (option: { body: Methods40['post']['reqBody'], config?: T }) =>
        fetch<Methods40['post']['resBody'], BasicHeaders, Methods40['post']['status']>(prefix, PATH33, POST, option).json().then(r => r.body),
      $path: (option?: { method?: 'get'; query: Methods40['get']['query'] }) =>
        `${prefix}${PATH33}${option && option.query ? `?${dataToURLString(option.query)}` : ''}`
    },
    questionnaire_answer: {
      _id: (val1: number) => {
        const prefix1 = `${PATH43}/${val1}`

        return {
          get: (option?: { config?: T }) =>
            fetch<Methods53['get']['resBody'], BasicHeaders, Methods53['get']['status']>(prefix, prefix1, GET, option).json(),
          $get: (option?: { config?: T }) =>
            fetch<Methods53['get']['resBody'], BasicHeaders, Methods53['get']['status']>(prefix, prefix1, GET, option).json().then(r => r.body),
          put: (option: { body: Methods53['put']['reqBody'], config?: T }) =>
            fetch<Methods53['put']['resBody'], BasicHeaders, Methods53['put']['status']>(prefix, prefix1, PUT, option).json(),
          $put: (option: { body: Methods53['put']['reqBody'], config?: T }) =>
            fetch<Methods53['put']['resBody'], BasicHeaders, Methods53['put']['status']>(prefix, prefix1, PUT, option).json().then(r => r.body),
          $path: () => `${prefix}${prefix1}`
        }
      },
      _questionnaireId: (val1: string) => {
        const prefix1 = `${PATH43}/${val1}`

        return {
          _answerId: (val2: string) => {
            const prefix2 = `${prefix1}/${val2}`

            return {
              put: (option: { body: Methods54['put']['reqBody'], query: Methods54['put']['query'], config?: T }) =>
                fetch<Methods54['put']['resBody'], BasicHeaders, Methods54['put']['status']>(prefix, prefix2, PUT, option).json(),
              $put: (option: { body: Methods54['put']['reqBody'], query: Methods54['put']['query'], config?: T }) =>
                fetch<Methods54['put']['resBody'], BasicHeaders, Methods54['put']['status']>(prefix, prefix2, PUT, option).json().then(r => r.body),
              $path: (option?: { method: 'put'; query: Methods54['put']['query'] }) =>
                `${prefix}${prefix2}${option && option.query ? `?${dataToURLString(option.query)}` : ''}`
            }
          }
        }
      },
      internal: {
        _monitorId: (val2: string) => {
          const prefix2 = `${PATH44}/${val2}`

          return {
            get: (option?: { config?: T }) =>
              fetch<void, BasicHeaders, Methods55['get']['status']>(prefix, prefix2, GET, option).send(),
            $get: (option?: { config?: T }) =>
              fetch<void, BasicHeaders, Methods55['get']['status']>(prefix, prefix2, GET, option).send().then(r => r.body),
            $path: () => `${prefix}${prefix2}`
          }
        }
      },
      results_requests: {
        post: (option: { body: Methods56['post']['reqBody'], config?: T }) =>
          fetch<Methods56['post']['resBody'], BasicHeaders, Methods56['post']['status']>(prefix, PATH45, POST, option).json(),
        $post: (option: { body: Methods56['post']['reqBody'], config?: T }) =>
          fetch<Methods56['post']['resBody'], BasicHeaders, Methods56['post']['status']>(prefix, PATH45, POST, option).json().then(r => r.body),
        $path: () => `${prefix}${PATH45}`
      },
      get: (option?: { query?: Methods52['get']['query'], config?: T }) =>
        fetch<Methods52['get']['resBody'], BasicHeaders, Methods52['get']['status']>(prefix, PATH43, GET, option).json(),
      $get: (option?: { query?: Methods52['get']['query'], config?: T }) =>
        fetch<Methods52['get']['resBody'], BasicHeaders, Methods52['get']['status']>(prefix, PATH43, GET, option).json().then(r => r.body),
      $path: (option?: { method?: 'get'; query: Methods52['get']['query'] }) =>
        `${prefix}${PATH43}${option && option.query ? `?${dataToURLString(option.query)}` : ''}`
    },
    questionnaire_page: {
      _page_id: (val1: number) => {
        const prefix1 = `${PATH46}/${val1}`

        return {
          get: (option?: { config?: T }) =>
            fetch<Methods58['get']['resBody'], BasicHeaders, Methods58['get']['status']>(prefix, prefix1, GET, option).json(),
          $get: (option?: { config?: T }) =>
            fetch<Methods58['get']['resBody'], BasicHeaders, Methods58['get']['status']>(prefix, prefix1, GET, option).json().then(r => r.body),
          put: (option: { body: Methods58['put']['reqBody'], config?: T }) =>
            fetch<Methods58['put']['resBody'], BasicHeaders, Methods58['put']['status']>(prefix, prefix1, PUT, option).json(),
          $put: (option: { body: Methods58['put']['reqBody'], config?: T }) =>
            fetch<Methods58['put']['resBody'], BasicHeaders, Methods58['put']['status']>(prefix, prefix1, PUT, option).json().then(r => r.body),
          delete: (option?: { config?: T }) =>
            fetch<Methods58['delete']['resBody'], BasicHeaders, Methods58['delete']['status']>(prefix, prefix1, DELETE, option).json(),
          $delete: (option?: { config?: T }) =>
            fetch<Methods58['delete']['resBody'], BasicHeaders, Methods58['delete']['status']>(prefix, prefix1, DELETE, option).json().then(r => r.body),
          $path: () => `${prefix}${prefix1}`
        }
      },
      get: (option: { query: Methods57['get']['query'], config?: T }) =>
        fetch<Methods57['get']['resBody'], BasicHeaders, Methods57['get']['status']>(prefix, PATH46, GET, option).json(),
      $get: (option: { query: Methods57['get']['query'], config?: T }) =>
        fetch<Methods57['get']['resBody'], BasicHeaders, Methods57['get']['status']>(prefix, PATH46, GET, option).json().then(r => r.body),
      post: (option: { body: Methods57['post']['reqBody'], config?: T }) =>
        fetch<Methods57['post']['resBody'], BasicHeaders, Methods57['post']['status']>(prefix, PATH46, POST, option).json(),
      $post: (option: { body: Methods57['post']['reqBody'], config?: T }) =>
        fetch<Methods57['post']['resBody'], BasicHeaders, Methods57['post']['status']>(prefix, PATH46, POST, option).json().then(r => r.body),
      $path: (option?: { method?: 'get'; query: Methods57['get']['query'] }) =>
        `${prefix}${PATH46}${option && option.query ? `?${dataToURLString(option.query)}` : ''}`
    },
    receipts: {
      _id: (val1: number) => {
        const prefix1 = `${PATH47}/${val1}`

        return {
          get: (option: { query: Methods60['get']['query'], config?: T }) =>
            fetch<Methods60['get']['resBody'], BasicHeaders, Methods60['get']['status']>(prefix, prefix1, GET, option).json(),
          $get: (option: { query: Methods60['get']['query'], config?: T }) =>
            fetch<Methods60['get']['resBody'], BasicHeaders, Methods60['get']['status']>(prefix, prefix1, GET, option).json().then(r => r.body),
          put: (option: { body: Methods60['put']['reqBody'], config?: T }) =>
            fetch<Methods60['put']['resBody'], BasicHeaders, Methods60['put']['status']>(prefix, prefix1, PUT, option).json(),
          $put: (option: { body: Methods60['put']['reqBody'], config?: T }) =>
            fetch<Methods60['put']['resBody'], BasicHeaders, Methods60['put']['status']>(prefix, prefix1, PUT, option).json().then(r => r.body),
          $path: (option?: { method?: 'get'; query: Methods60['get']['query'] }) =>
            `${prefix}${prefix1}${option && option.query ? `?${dataToURLString(option.query)}` : ''}`
        }
      },
      bigquery_csv: {
        get: (option?: { config?: T }) =>
          fetch<void, BasicHeaders, Methods61['get']['status']>(prefix, PATH48, GET, option).send(),
        $get: (option?: { config?: T }) =>
          fetch<void, BasicHeaders, Methods61['get']['status']>(prefix, PATH48, GET, option).send().then(r => r.body),
        $path: () => `${prefix}${PATH48}`
      },
      checkDuplicated: {
        post: (option: { body: Methods62['post']['reqBody'], config?: T }) =>
          fetch<Methods62['post']['resBody'], BasicHeaders, Methods62['post']['status']>(prefix, PATH49, POST, option).json(),
        $post: (option: { body: Methods62['post']['reqBody'], config?: T }) =>
          fetch<Methods62['post']['resBody'], BasicHeaders, Methods62['post']['status']>(prefix, PATH49, POST, option).json().then(r => r.body),
        $path: () => `${prefix}${PATH49}`
      },
      chobirich: {
        remaind_count: {
          get: (option: { query: Methods63['get']['query'], config?: T }) =>
            fetch<void, BasicHeaders, Methods63['get']['status']>(prefix, PATH50, GET, option).send(),
          $get: (option: { query: Methods63['get']['query'], config?: T }) =>
            fetch<void, BasicHeaders, Methods63['get']['status']>(prefix, PATH50, GET, option).send().then(r => r.body),
          $path: (option?: { method?: 'get'; query: Methods63['get']['query'] }) =>
            `${prefix}${PATH50}${option && option.query ? `?${dataToURLString(option.query)}` : ''}`
        },
        upload_image: {
          post: (option: { body: Methods64['post']['reqBody'], config?: T }) =>
            fetch<Methods64['post']['resBody'], BasicHeaders, Methods64['post']['status']>(prefix, PATH51, POST, option, 'FormData').text(),
          $post: (option: { body: Methods64['post']['reqBody'], config?: T }) =>
            fetch<Methods64['post']['resBody'], BasicHeaders, Methods64['post']['status']>(prefix, PATH51, POST, option, 'FormData').text().then(r => r.body),
          $path: () => `${prefix}${PATH51}`
        }
      },
      contributers: {
        get: (option: { query: Methods65['get']['query'], config?: T }) =>
          fetch<Methods65['get']['resBody'], BasicHeaders, Methods65['get']['status']>(prefix, PATH52, GET, option).json(),
        $get: (option: { query: Methods65['get']['query'], config?: T }) =>
          fetch<Methods65['get']['resBody'], BasicHeaders, Methods65['get']['status']>(prefix, PATH52, GET, option).json().then(r => r.body),
        $path: (option?: { method?: 'get'; query: Methods65['get']['query'] }) =>
          `${prefix}${PATH52}${option && option.query ? `?${dataToURLString(option.query)}` : ''}`
      },
      contributers_csv: {
        get: (option?: { config?: T }) =>
          fetch<void, BasicHeaders, Methods66['get']['status']>(prefix, PATH53, GET, option).send(),
        $get: (option?: { config?: T }) =>
          fetch<void, BasicHeaders, Methods66['get']['status']>(prefix, PATH53, GET, option).send().then(r => r.body),
        $path: () => `${prefix}${PATH53}`
      },
      internal: {
        remained_count: {
          _monitorId: (val3: string) => {
            const prefix3 = `${PATH54}/${val3}`

            return {
              get: (option?: { config?: T }) =>
                fetch<void, BasicHeaders, Methods67['get']['status']>(prefix, prefix3, GET, option).send(),
              $get: (option?: { config?: T }) =>
                fetch<void, BasicHeaders, Methods67['get']['status']>(prefix, prefix3, GET, option).send().then(r => r.body),
              $path: () => `${prefix}${prefix3}`
            }
          }
        }
      },
      is_existing_image_id: {
        _imageId: (val2: string) => {
          const prefix2 = `${PATH55}/${val2}`

          return {
            get: (option?: { config?: T }) =>
              fetch<void, BasicHeaders, Methods68['get']['status']>(prefix, prefix2, GET, option).send(),
            $get: (option?: { config?: T }) =>
              fetch<void, BasicHeaders, Methods68['get']['status']>(prefix, prefix2, GET, option).send().then(r => r.body),
            $path: () => `${prefix}${prefix2}`
          }
        }
      },
      mock_questionnaire: {
        _id: (val2: string) => {
          const prefix2 = `${PATH56}/${val2}`

          return {
            _questionnaireId: (val3: number) => {
              const prefix3 = `${prefix2}/${val3}`

              return {
                get: (option?: { config?: T }) =>
                  fetch<void, BasicHeaders, Methods69['get']['status']>(prefix, prefix3, GET, option).send(),
                $get: (option?: { config?: T }) =>
                  fetch<void, BasicHeaders, Methods69['get']['status']>(prefix, prefix3, GET, option).send().then(r => r.body),
                $path: () => `${prefix}${prefix3}`
              }
            }
          }
        }
      },
      results_requests: {
        post: (option: { body: Methods70['post']['reqBody'], config?: T }) =>
          fetch<Methods70['post']['resBody'], BasicHeaders, Methods70['post']['status']>(prefix, PATH57, POST, option).json(),
        $post: (option: { body: Methods70['post']['reqBody'], config?: T }) =>
          fetch<Methods70['post']['resBody'], BasicHeaders, Methods70['post']['status']>(prefix, PATH57, POST, option).json().then(r => r.body),
        get: (option?: { config?: T }) =>
          fetch<Methods70['get']['resBody'], BasicHeaders, Methods70['get']['status']>(prefix, PATH57, GET, option).json(),
        $get: (option?: { config?: T }) =>
          fetch<Methods70['get']['resBody'], BasicHeaders, Methods70['get']['status']>(prefix, PATH57, GET, option).json().then(r => r.body),
        $path: () => `${prefix}${PATH57}`
      },
      results_requests_by_ids: {
        get: (option?: { config?: T }) =>
          fetch<Methods71['get']['resBody'], BasicHeaders, Methods71['get']['status']>(prefix, PATH58, GET, option).json(),
        $get: (option?: { config?: T }) =>
          fetch<Methods71['get']['resBody'], BasicHeaders, Methods71['get']['status']>(prefix, PATH58, GET, option).json().then(r => r.body),
        $path: () => `${prefix}${PATH58}`
      },
      snapShot: {
        get: (option?: { config?: T }) =>
          fetch<Methods72['get']['resBody'], BasicHeaders, Methods72['get']['status']>(prefix, PATH59, GET, option).json(),
        $get: (option?: { config?: T }) =>
          fetch<Methods72['get']['resBody'], BasicHeaders, Methods72['get']['status']>(prefix, PATH59, GET, option).json().then(r => r.body),
        $path: () => `${prefix}${PATH59}`
      },
      summaries: {
        get: (option: { query: Methods73['get']['query'], config?: T }) =>
          fetch<Methods73['get']['resBody'], BasicHeaders, Methods73['get']['status']>(prefix, PATH60, GET, option).json(),
        $get: (option: { query: Methods73['get']['query'], config?: T }) =>
          fetch<Methods73['get']['resBody'], BasicHeaders, Methods73['get']['status']>(prefix, PATH60, GET, option).json().then(r => r.body),
        $path: (option?: { method?: 'get'; query: Methods73['get']['query'] }) =>
          `${prefix}${PATH60}${option && option.query ? `?${dataToURLString(option.query)}` : ''}`
      },
      post: (option: { body: Methods59['post']['reqBody'], config?: T }) =>
        fetch<Methods59['post']['resBody'], BasicHeaders, Methods59['post']['status']>(prefix, PATH47, POST, option).json(),
      $post: (option: { body: Methods59['post']['reqBody'], config?: T }) =>
        fetch<Methods59['post']['resBody'], BasicHeaders, Methods59['post']['status']>(prefix, PATH47, POST, option).json().then(r => r.body),
      get: (option: { query: Methods59['get']['query'], config?: T }) =>
        fetch<Methods59['get']['resBody'], BasicHeaders, Methods59['get']['status']>(prefix, PATH47, GET, option).json(),
      $get: (option: { query: Methods59['get']['query'], config?: T }) =>
        fetch<Methods59['get']['resBody'], BasicHeaders, Methods59['get']['status']>(prefix, PATH47, GET, option).json().then(r => r.body),
      $path: (option?: { method?: 'get'; query: Methods59['get']['query'] }) =>
        `${prefix}${PATH47}${option && option.query ? `?${dataToURLString(option.query)}` : ''}`
    },
    recommend: {
      get: (option: { query: Methods74['get']['query'], config?: T }) =>
        fetch<Methods74['get']['resBody'], BasicHeaders, Methods74['get']['status']>(prefix, PATH61, GET, option).json(),
      $get: (option: { query: Methods74['get']['query'], config?: T }) =>
        fetch<Methods74['get']['resBody'], BasicHeaders, Methods74['get']['status']>(prefix, PATH61, GET, option).json().then(r => r.body),
      $path: (option?: { method?: 'get'; query: Methods74['get']['query'] }) =>
        `${prefix}${PATH61}${option && option.query ? `?${dataToURLString(option.query)}` : ''}`
    },
    shops: {
      _id: (val1: string) => {
        const prefix1 = `${PATH62}/${val1}`

        return {
          get: (option?: { config?: T }) =>
            fetch<Methods76['get']['resBody'], BasicHeaders, Methods76['get']['status']>(prefix, prefix1, GET, option).json(),
          $get: (option?: { config?: T }) =>
            fetch<Methods76['get']['resBody'], BasicHeaders, Methods76['get']['status']>(prefix, prefix1, GET, option).json().then(r => r.body),
          put: (option: { body: Methods76['put']['reqBody'], config?: T }) =>
            fetch<Methods76['put']['resBody'], BasicHeaders, Methods76['put']['status']>(prefix, prefix1, PUT, option).json(),
          $put: (option: { body: Methods76['put']['reqBody'], config?: T }) =>
            fetch<Methods76['put']['resBody'], BasicHeaders, Methods76['put']['status']>(prefix, prefix1, PUT, option).json().then(r => r.body),
          $path: () => `${prefix}${prefix1}`
        }
      },
      post: (option: { body: Methods75['post']['reqBody'], config?: T }) =>
        fetch<Methods75['post']['resBody'], BasicHeaders, Methods75['post']['status']>(prefix, PATH62, POST, option).json(),
      $post: (option: { body: Methods75['post']['reqBody'], config?: T }) =>
        fetch<Methods75['post']['resBody'], BasicHeaders, Methods75['post']['status']>(prefix, PATH62, POST, option).json().then(r => r.body),
      get: (option: { query: Methods75['get']['query'], config?: T }) =>
        fetch<Methods75['get']['resBody'], BasicHeaders, Methods75['get']['status']>(prefix, PATH62, GET, option).json(),
      $get: (option: { query: Methods75['get']['query'], config?: T }) =>
        fetch<Methods75['get']['resBody'], BasicHeaders, Methods75['get']['status']>(prefix, PATH62, GET, option).json().then(r => r.body),
      $path: (option?: { method?: 'get'; query: Methods75['get']['query'] }) =>
        `${prefix}${PATH62}${option && option.query ? `?${dataToURLString(option.query)}` : ''}`
    },
    slogs: {
      slogs_csv: {
        get: (option?: { query?: Methods78['get']['query'], config?: T }) =>
          fetch<void, BasicHeaders, Methods78['get']['status']>(prefix, PATH64, GET, option).send(),
        $get: (option?: { query?: Methods78['get']['query'], config?: T }) =>
          fetch<void, BasicHeaders, Methods78['get']['status']>(prefix, PATH64, GET, option).send().then(r => r.body),
        $path: (option?: { method?: 'get'; query: Methods78['get']['query'] }) =>
          `${prefix}${PATH64}${option && option.query ? `?${dataToURLString(option.query)}` : ''}`
      },
      post: (option: { body: Methods77['post']['reqBody'], config?: T }) =>
        fetch<Methods77['post']['resBody'], BasicHeaders, Methods77['post']['status']>(prefix, PATH63, POST, option).json(),
      $post: (option: { body: Methods77['post']['reqBody'], config?: T }) =>
        fetch<Methods77['post']['resBody'], BasicHeaders, Methods77['post']['status']>(prefix, PATH63, POST, option).json().then(r => r.body),
      get: (option?: { query?: Methods77['get']['query'], config?: T }) =>
        fetch<Methods77['get']['resBody'], BasicHeaders, Methods77['get']['status']>(prefix, PATH63, GET, option).json(),
      $get: (option?: { query?: Methods77['get']['query'], config?: T }) =>
        fetch<Methods77['get']['resBody'], BasicHeaders, Methods77['get']['status']>(prefix, PATH63, GET, option).json().then(r => r.body),
      $path: (option?: { method?: 'get'; query: Methods77['get']['query'] }) =>
        `${prefix}${PATH63}${option && option.query ? `?${dataToURLString(option.query)}` : ''}`
    },
    special_offer_receipts: {
      _id: (val1: number) => {
        const prefix1 = `${PATH65}/${val1}`

        return {
          get: (option?: { config?: T }) =>
            fetch<Methods80['get']['resBody'], BasicHeaders, Methods80['get']['status']>(prefix, prefix1, GET, option).json(),
          $get: (option?: { config?: T }) =>
            fetch<Methods80['get']['resBody'], BasicHeaders, Methods80['get']['status']>(prefix, prefix1, GET, option).json().then(r => r.body),
          put: (option: { body: Methods80['put']['reqBody'], config?: T }) =>
            fetch<Methods80['put']['resBody'], BasicHeaders, Methods80['put']['status']>(prefix, prefix1, PUT, option).json(),
          $put: (option: { body: Methods80['put']['reqBody'], config?: T }) =>
            fetch<Methods80['put']['resBody'], BasicHeaders, Methods80['put']['status']>(prefix, prefix1, PUT, option).json().then(r => r.body),
          $path: () => `${prefix}${prefix1}`
        }
      },
      internal: {
        post: (option: { body: Methods81['post']['reqBody'], config?: T }) =>
          fetch<Methods81['post']['resBody'], BasicHeaders, Methods81['post']['status']>(prefix, PATH66, POST, option).json(),
        $post: (option: { body: Methods81['post']['reqBody'], config?: T }) =>
          fetch<Methods81['post']['resBody'], BasicHeaders, Methods81['post']['status']>(prefix, PATH66, POST, option).json().then(r => r.body),
        get: (option: { query: Methods81['get']['query'], config?: T }) =>
          fetch<Methods81['get']['resBody'], BasicHeaders, Methods81['get']['status']>(prefix, PATH66, GET, option).json(),
        $get: (option: { query: Methods81['get']['query'], config?: T }) =>
          fetch<Methods81['get']['resBody'], BasicHeaders, Methods81['get']['status']>(prefix, PATH66, GET, option).json().then(r => r.body),
        $path: (option?: { method?: 'get'; query: Methods81['get']['query'] }) =>
          `${prefix}${PATH66}${option && option.query ? `?${dataToURLString(option.query)}` : ''}`
      },
      internal_by_imported_at: {
        get: (option: { query: Methods82['get']['query'], config?: T }) =>
          fetch<Methods82['get']['resBody'], BasicHeaders, Methods82['get']['status']>(prefix, PATH67, GET, option).json(),
        $get: (option: { query: Methods82['get']['query'], config?: T }) =>
          fetch<Methods82['get']['resBody'], BasicHeaders, Methods82['get']['status']>(prefix, PATH67, GET, option).json().then(r => r.body),
        $path: (option?: { method?: 'get'; query: Methods82['get']['query'] }) =>
          `${prefix}${PATH67}${option && option.query ? `?${dataToURLString(option.query)}` : ''}`
      },
      get: (option?: { query?: Methods79['get']['query'], config?: T }) =>
        fetch<Methods79['get']['resBody'], BasicHeaders, Methods79['get']['status']>(prefix, PATH65, GET, option).json(),
      $get: (option?: { query?: Methods79['get']['query'], config?: T }) =>
        fetch<Methods79['get']['resBody'], BasicHeaders, Methods79['get']['status']>(prefix, PATH65, GET, option).json().then(r => r.body),
      $path: (option?: { method?: 'get'; query: Methods79['get']['query'] }) =>
        `${prefix}${PATH65}${option && option.query ? `?${dataToURLString(option.query)}` : ''}`
    },
    special_offers: {
      _id: (val1: string) => {
        const prefix1 = `${PATH68}/${val1}`

        return {
          get: (option?: { config?: T }) =>
            fetch<Methods84['get']['resBody'], BasicHeaders, Methods84['get']['status']>(prefix, prefix1, GET, option).json(),
          $get: (option?: { config?: T }) =>
            fetch<Methods84['get']['resBody'], BasicHeaders, Methods84['get']['status']>(prefix, prefix1, GET, option).json().then(r => r.body),
          put: (option: { body: Methods84['put']['reqBody'], config?: T }) =>
            fetch<Methods84['put']['resBody'], BasicHeaders, Methods84['put']['status']>(prefix, prefix1, PUT, option).json(),
          $put: (option: { body: Methods84['put']['reqBody'], config?: T }) =>
            fetch<Methods84['put']['resBody'], BasicHeaders, Methods84['put']['status']>(prefix, prefix1, PUT, option).json().then(r => r.body),
          $path: () => `${prefix}${prefix1}`
        }
      },
      internal: {
        post: (option: { body: Methods85['post']['reqBody'], config?: T }) =>
          fetch<Methods85['post']['resBody'], BasicHeaders, Methods85['post']['status']>(prefix, PATH69, POST, option).json(),
        $post: (option: { body: Methods85['post']['reqBody'], config?: T }) =>
          fetch<Methods85['post']['resBody'], BasicHeaders, Methods85['post']['status']>(prefix, PATH69, POST, option).json().then(r => r.body),
        $path: () => `${prefix}${PATH69}`
      },
      get: (option?: { query?: Methods83['get']['query'], config?: T }) =>
        fetch<Methods83['get']['resBody'], BasicHeaders, Methods83['get']['status']>(prefix, PATH68, GET, option).json(),
      $get: (option?: { query?: Methods83['get']['query'], config?: T }) =>
        fetch<Methods83['get']['resBody'], BasicHeaders, Methods83['get']['status']>(prefix, PATH68, GET, option).json().then(r => r.body),
      $path: (option?: { method?: 'get'; query: Methods83['get']['query'] }) =>
        `${prefix}${PATH68}${option && option.query ? `?${dataToURLString(option.query)}` : ''}`
    },
    users: {
      _id: (val1: number) => {
        const prefix1 = `${PATH70}/${val1}`

        return {
          get: (option?: { config?: T }) =>
            fetch<Methods87['get']['resBody'], BasicHeaders, Methods87['get']['status']>(prefix, prefix1, GET, option).json(),
          $get: (option?: { config?: T }) =>
            fetch<Methods87['get']['resBody'], BasicHeaders, Methods87['get']['status']>(prefix, prefix1, GET, option).json().then(r => r.body),
          put: (option: { body: Methods87['put']['reqBody'], config?: T }) =>
            fetch<Methods87['put']['resBody'], BasicHeaders, Methods87['put']['status']>(prefix, prefix1, PUT, option).json(),
          $put: (option: { body: Methods87['put']['reqBody'], config?: T }) =>
            fetch<Methods87['put']['resBody'], BasicHeaders, Methods87['put']['status']>(prefix, prefix1, PUT, option).json().then(r => r.body),
          delete: (option?: { config?: T }) =>
            fetch<Methods87['delete']['resBody'], BasicHeaders, Methods87['delete']['status']>(prefix, prefix1, DELETE, option).json(),
          $delete: (option?: { config?: T }) =>
            fetch<Methods87['delete']['resBody'], BasicHeaders, Methods87['delete']['status']>(prefix, prefix1, DELETE, option).json().then(r => r.body),
          $path: () => `${prefix}${prefix1}`
        }
      },
      post: (option: { body: Methods86['post']['reqBody'], config?: T }) =>
        fetch<Methods86['post']['resBody'], BasicHeaders, Methods86['post']['status']>(prefix, PATH70, POST, option).json(),
      $post: (option: { body: Methods86['post']['reqBody'], config?: T }) =>
        fetch<Methods86['post']['resBody'], BasicHeaders, Methods86['post']['status']>(prefix, PATH70, POST, option).json().then(r => r.body),
      get: (option?: { config?: T }) =>
        fetch<Methods86['get']['resBody'], BasicHeaders, Methods86['get']['status']>(prefix, PATH70, GET, option).json(),
      $get: (option?: { config?: T }) =>
        fetch<Methods86['get']['resBody'], BasicHeaders, Methods86['get']['status']>(prefix, PATH70, GET, option).json().then(r => r.body),
      $path: () => `${prefix}${PATH70}`
    },
    /**
     * @returns The Health Check is successful
     */
    get: (option?: { config?: T }) =>
      fetch<Methods0['get']['resBody'], BasicHeaders, Methods0['get']['status']>(prefix, '', GET, option).json(),
    /**
     * @returns The Health Check is successful
     */
    $get: (option?: { config?: T }) =>
      fetch<Methods0['get']['resBody'], BasicHeaders, Methods0['get']['status']>(prefix, '', GET, option).json().then(r => r.body),
    $path: () => `${prefix}`
  }
}

// prettier-ignore
export type ApiInstance = ReturnType<typeof api>
// prettier-ignore
export default api
